// SPDX-License-Identifier: LicenseRef-Proprietary

import React, { useState } from "react";
import { TextField } from "../../VaccineDashboard/components/TextField";
import { ConfirmationDialog } from "./ConfirmationDialog";

interface VaccineDashboardHeaderProps {
  disease: string;
  handleDiseaseChange: (value: string) => void;
  addScenario: () => void;
  handleExport: () => void;
  handleImport: () => void;
  onOpenScenarioManager: () => void;
  scenarioCount: number;
  onReset: () => void;
}

export const VaccineDashboardHeader: React.FC<VaccineDashboardHeaderProps> = ({
  disease,
  handleDiseaseChange,
  addScenario,
  handleExport,
  handleImport,
  onOpenScenarioManager,
  scenarioCount,
  onReset,
}) => {
  const [showResetConfirm, setShowResetConfirm] = useState(false);
  return (
    <header>
      <div>
        {/* <div className="vaccine-demo__title">
          <div className="vaccine-demo__logo">
            <span className="vaccine-demo__brand-prefix">EASY</span>
            <span className="vaccine-demo__brand-suffix">HTA</span>
          </div>
          <div>
            <div>Vaccine Value — Finland</div>
          </div>
        </div> */}

        <div className="vaccine-demo__header-controls">
          <TextField
            label="Enter title"
            value={disease}
            onChange={(value) => handleDiseaseChange(value)}
            aria-label="Disease type"
            hideLabel={true}
            debounceMs={0}
          ></TextField>

          <button
            onClick={onOpenScenarioManager}
            className="btn btn-secondary"
            aria-label="Manage scenarios"
            style={{ position: 'relative' }}
          >
            Scenarios
            {scenarioCount > 0 && (
              <span style={{
                position: 'absolute',
                top: '-6px',
                right: '-6px',
                background: '#3b82f6',
                color: 'white',
                fontSize: '10px',
                padding: '2px 6px',
                borderRadius: '10px',
                fontWeight: 'bold'
              }}>
                {scenarioCount}
              </span>
            )}
          </button>

          <button
            onClick={addScenario}
            className="btn btn-secondary"
            aria-label="Save current scenario"
          >
            Save scenario
          </button>

          <button
            onClick={handleExport}
            className="btn btn-primary"
            aria-label="Export results"
          >
            Export
          </button>
          <button
            onClick={handleImport}
            className="btn btn-primary"
            aria-label="Export results"
          >
            Import
          </button>

          <button
            onClick={() => setShowResetConfirm(true)}
            className="btn btn-danger vaccine-demo__reset-btn"
            aria-label="Reset all inputs to defaults"
            style={{
              background: '#dc2626',
              borderColor: '#dc2626',
            }}
          >
            Reset All
          </button>
        </div>
      </div>

      <ConfirmationDialog
        isOpen={showResetConfirm}
        title="Reset All Inputs?"
        message="This will reset all model inputs to their default values. Any unsaved changes will be lost. This action cannot be undone."
        confirmText="Reset All"
        cancelText="Cancel"
        variant="danger"
        onConfirm={() => {
          onReset();
          setShowResetConfirm(false);
        }}
        onCancel={() => setShowResetConfirm(false)}
      />
    </header>
  );
};
